/* eslint-disable */
import React, { Component, useCallback, useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { is } from 'immutable';
import { useMount, useUnmount } from 'react-use';
import { useLocation, useHistory, Link } from 'react-router-dom';
import { withQuery } from '@/utils';
import { Empty, Button, Badge, Radio, Popover, Tabs, Divider, Pagination, Spin, Modal, PageHeader, message } from 'antd';
import { MessageOutlined } from '@ant-design/icons';
import styles from './styles.module.less';
import {
  getConvIdsSelector,
  totalUnreadCountSelector,
  currentConvIdSelector,
  currentOrderIdSelector,
  getConvEntriesSelector,
  getConvStats,
  convRefreshKeySelector
} from '@/models/conversations/selectors';
import { getCurrentUser } from '@/models/user/selectors';
import { getGroupManagerSelector } from '@/models/managers/selectors';
import { getStaffConvsSelector } from '@/models/tenants/selectors';
import { taskRefreshKeySelector, chaoshiRefreshKeySelector, orderUpdateRefreshKeySelector } from '@/models/taskHall/selectors';
import { fetchConvs, navToOrderConv, queryConvStats, resetConvs } from '@/models/conversations/actions';
import { fetchGroupManager } from '@/models/managers/actions';
import { fetchStaffConvs } from '@/models/tenants/actions';
import TaskHall from './components/TaskHall';
import Conversations from './components/Conversations';
import {
  navToConversation
} from '@/models/conversations/actions';
import OrderDetail from './components/OrderDetail';
import MessageList from './components/MessageBox/List'
import MessageBox from './components/MessageBox';
import TeamMember from './components/TeamMember';
import cn from 'classnames'
import * as apis from '@/apis'
import * as actions from '@/models/orders/actions';
import * as taskHallActions from '@/models/taskHall/actions';
import * as taskHallServices from '@/models/taskHall/services';
import { TaskItem } from "./components/TaskHall/index";
import SearchForm from './components/SearchForm'
import RetailCode from '@/components/RetailCode'

const { TabPane } = Tabs;
const docTitle = document.title;
const isTenantMode = process.env.APP_MODE === 'tenant';
const isManagerMode = process.env.APP_MODE === 'manager';
const APP_MODE = process.env.APP_MODE === 'tenant' ? "staff" : "manager"

function Workspace(props) {
  const history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();
  const convIds = useSelector(getConvIdsSelector, is);
  const convs = useSelector(getConvEntriesSelector)
  const myUnread = useSelector(totalUnreadCountSelector);
  const groupManager = useSelector(getGroupManagerSelector);
  const staffConvs = useSelector(getStaffConvsSelector);
  const currentOrderId = useSelector(currentOrderIdSelector);
  const currentConvId = useSelector(currentConvIdSelector);
  //待接收的订单会话总数
  const unAcceptCount = useSelector(getConvStats(1));
  //预约超时的订单会话总数
  const dateOverTimeCount = useSelector(getConvStats(2));
  //上门超时的订单会话总数
  const serviceOverTimeCount = useSelector(getConvStats(3));
  //申诉、调价待审核订单会话总数
  const unApprovalCount = useSelector(getConvStats(4));
  const taskRefreshKey = useSelector(taskRefreshKeySelector);
  const chaoshiRefreshKey = useSelector(chaoshiRefreshKeySelector);
  const convRefreshKey = useSelector(convRefreshKeySelector);
  const orderUpdateRefreshKey = useSelector(orderUpdateRefreshKeySelector);

  const [queryType, setQueryType] = React.useState(0);
  const [userName, setUserName] = React.useState("我");
  const [totalUnread, setTotalUnread] = React.useState(myUnread);
  const [showChatHistory, setShowChatHistory] = useState(false);
  const [taskLoading, setTaskLoading] = useState(false);
  const [taskList, setTaskList] = useState([]);
  const [total, setTotal] = useState(0);
  const [limit, setLimit] = useState(10);
  const [offset, setOffset] = useState(0);
  const [convsType, setConvsType] = useState(0);
  const [convsUserId, setConvsUserId] = useState('');
  const [tastHallType, setTastHallType] = useState(0);
  const [showTaskFold, setShowTaskFold] = useState(false);

  const [taskFoldTotal, setTaskFoldTotal] = useState(0);
  const [taskFoldLimit, setTaskFoldLimit] = useState(10);
  const [taskFoldOffset, setTaskFoldOffset] = useState(0);
  const [taskFoldList, setTaskFoldList] = useState([]);
  const [showConvFold, setShowConvFold] = useState(false);
  const [taskCount, setTaskCount] = useState({});
  const [chaoshiCount, setChaoshiCount] = useState({});
  const [baowaiCount, setBaowaiCount] = useState({});
  const [myCount, setMyCount] = useState({});


  const [taskHallSelectOrderId, setTaskHallSelectOrderId] = useState('');
  const [convSelectOrderId, setConvSelectOrderId] = useState('');

  const [activeStaff, setActiveStaff] = useState({});
  const [isInit, setIsInit] = useState(true);

  const taskListRef = useRef(null)
  const middleConvRef = useRef(null)
  const searchFormRef = useRef(null)

  const user = useSelector(getCurrentUser);
  const id = user.getIn([APP_MODE, "_id"])
  const showOrderCreator = useCallback((user, id) => {
    if (user.get('originTenant') === 0) {
      message.warning('请使用该子账号的员工账号创建订单')
      return false
    }
    dispatch(
      actions.showCreateOrderDialog({
        title: '创建工单',
        user,
        dispatch
      })
    );
    /*
    apis.getStaffs(id).then(res => {
      if (!(res.address.length > 0)) {
        message.warning('请前往工单配置页面添加完单图片反馈要求')
        return false
      }
      if (!(res.feedback_demand.length > 0)) {
        message.warning('请前往工单配置页面添加反件地址')
        return false
      }
      if (res.address.length > 0 && res.feedback_demand.length > 0) {
        dispatch(
          actions.showCreateOrderDialog({
            title: '创建工单',
            user,
          })
        );
      }
    })*/
  }, []);
  // const queryConvs = e => {
  //   const payload = {};
  //   setQueryType(e.target.value);
  //   payload.queryType = e.target.value;

  //   setConvsType(payload.queryType)
  //   setConvsUserId('')

  //   dispatch(fetchConvs(payload));
  //   setUserName('我');
  //   let userId = user.get('_id')
  //   calUserUnRead(userId);
  // };
  // const queryConvsById = (id, type, realname, unread) => {
  //   const payload = {};
  //   payload.queryType = type //查询指定用户的回话
  //   if (id) {
  //     payload.user_id = id
  //   }
  //   setConvsType(type)
  //   setConvsUserId(id)

  //   dispatch(fetchConvs(payload));
  //   setQueryType(null);
  //   setUserName(realname);
  //   if (unread >= 0) {
  //     setTotalUnread(unread)
  //   } else {
  //     calUserUnRead(id);
  //   }
  // }


  const getTaskFoldData = () => {
    setTaskLoading(true);
    taskHallServices.fetchTask({
      type: tastHallType,
      offset: taskFoldOffset,
      limit: taskFoldLimit,
      is_fold: 1
    }).then(result => {
      setTaskFoldList(result.data);
      setTaskFoldTotal(result.total)
      // dispatch(actions.taskFetched(result)); // 倒是可以更新列表，不浪费资源 😁
    }).catch((err) => {
      message.error(err.message || '获取列表失败，请刷新重试');
    }).finally(() => { setTaskLoading(false); });
  }

  const handleTaskFoldChange = (page, pageSize) => {
    setTaskFoldOffset((page - 1) * taskFoldLimit)
  }

  const calUserUnRead = (userId) => {

    let total = 0
    convs.forEach(item => {
      total += (item?.get('user') === userId ? item?.get('unread_count') : 0)
    })
    setTotalUnread(total)
  }
  const getTotal = parmas => {
    let total = 0;
    parmas?.map(item => {
      total += item.unread;
    })
    return total;
  };

  const getTopTotal = parmas => {
    let total = 0;
    parmas?.map(item => {
      item.mgroup?.map(mgroup => {
        total += mgroup.unread;
      })
    })
    return total;
  };

  const getTenantTotal = parmas => {
    let total = 0;
    parmas?.map(item => {
      total += item.unread;
    })
    return total;
  };

  const fetchTaskData = (params) => {
    setTaskLoading(true);
    if (taskListRef.current && taskListRef.current.scrollTop) {
      taskListRef.current.scrollTop = 0
    }

    taskHallServices.fetchTask({
      type: tastHallType,
      offset: offset,
      limit: limit,
    }).then(result => {
      setTaskList(result.data);
      setTotal(result.total);
      // dispatch(actions.taskFetched(result)); // 倒是可以更新列表，不浪费资源 😁
    }).catch((err) => {
      message.error(err?.message || '获取列表失败，请刷新重试');
    })
      .finally(() => {
        setTaskLoading(false);
      });
  };
  const fetchTaskCountData = (type = 0) => {
    // 任务大厅：0，超时工单：1，我的消息：2，企业工作台数据：4
    if (isManagerMode) {
      taskHallServices.fetchTaskCount({
        type: 0,
      }).then(result => {
        setTaskCount(result || {})
      }).catch((err) => { })
      taskHallServices.fetchTaskCount({
        type: 1,
      }).then(result => {
        setChaoshiCount(result || {})
      }).catch((err) => { })

      taskHallServices.fetchTaskCount({
        type: 6,
      }).then(result => {
        setBaowaiCount(result || {})
      }).catch((err) => { })
      taskHallServices.fetchTaskCount({
        type: 2,
      }).then(result => {
        setMyCount(result || {})
      }).catch((err) => { })
    } else if (isTenantMode) {
      taskHallServices.fetchTaskCount({
        type: 4,
      }).then(result => {
        setMyCount(result || {})
      }).catch((err) => { })
    }

  };

  const clickTastHallType = (type) => {
    if (tastHallType == type) return false
    setTaskList([]);
    setTotal(0);
    setTastHallType(type)
    setOffset(0)

    setTaskFoldList([]);
    setTaskFoldTotal(0);
    setTaskFoldOffset(0)
  }
  const handleTaskChange = (page, pageSize) => {
    setOffset((page - 1) * limit)
  }
  // const initConvs = () => {
  //   const payload = {};
  //   payload.queryType = isTenantMode ? 4 : 2;
  //   if (location?.state?.order) {
  //     payload.orderId = location.state.order;
  //     history.replace(location.pathname); // delete old state
  //   } else {
  //     const prevActiveId = localStorage.getItem(
  //       `current_conv_item_${process.env.APP_MODE}`
  //     );
  //     payload.convId = prevActiveId;

  //     localStorage.removeItem(`current_conv_item_${process.env.APP_MODE}`); // clear cache
  //   }

  //   setConvsType(payload.queryType)
  //   setConvsUserId('')

  //   dispatch(fetchConvs(payload));
  //   if (isManagerMode) {
  //     dispatch(fetchGroupManager(payload));
  //     dispatch(queryConvStats(1))
  //     dispatch(queryConvStats(2))
  //     dispatch(queryConvStats(3))
  //     dispatch(queryConvStats(4))
  //   }
  //   if (isTenantMode) {
  //     dispatch(fetchStaffConvs(payload));
  //   }
  // }

  useEffect(() => {
    if (isManagerMode) {
      fetchTaskData()
      // fetchTaskCountData()
    }
  }, [offset, tastHallType])

  useEffect(() => {
    if (!isInit && isManagerMode) {
      getTaskFoldData()
    }
  }, [taskFoldOffset])

  useEffect(() => {
    if (isManagerMode && taskRefreshKey !== 'initkey') {
      fetchTaskData()
      fetchTaskCountData()
    }
  }, [taskRefreshKey])

  useEffect(() => {
    if (isManagerMode && orderUpdateRefreshKey !== 'initkey') {
      if (tastHallType === 6) {
        fetchTaskData()
        fetchTaskCountData()
      }
    }
  }, [orderUpdateRefreshKey])

  useEffect(() => {
    if (isManagerMode && chaoshiRefreshKey !== 'initkey' && tastHallType == 1) {
      fetchTaskData()
      fetchTaskCountData()
    }
  }, [chaoshiRefreshKey])

  useEffect(() => {
    if (convRefreshKey !== 'initkey') {
      fetchTaskCountData()
    }
  }, [convRefreshKey])

  useMount(() => {
    setIsInit(false)
    // if (isManagerMode) {
    //   fetchTaskData()
    // }
    fetchTaskCountData()
    // initConvs()
    if (location?.state?.searchOrderNo && isTenantMode) {
      searchFormRef.current?.searchData({
        keyword: location?.state?.searchOrderNo, callback: (data) => {
          let item = (data.data || [])[0] || {}
          if (item?._id && item?.order_id) {
            setConvSelectOrderId(item?.order_id)
            dispatch(navToConversation(item?._id, item?.order_id));
          }
        }
      })
      history.replace(location.pathname); // delete old state
    }
  });

  useUnmount(() => {
    window.document.title = docTitle;
  });


  return (
    <div className={styles.container}>
      {isManagerMode && !user.getIn(['manager', 'isWorking']) && <div className={styles.workmask}>休息中...</div>}
      {/* <DocumentTitle title={totalUnread? '（有未读消息）' + docTitle: docTitle} /> */}
      {/* <div className={styles.header}>
        {
          isTenantMode ? (
            <>
              <Button
                onClick={showOrderCreator.bind(this, user, id)}
                type="primary"
                className={styles.createBtn}
              >
                创建工单
              </Button>
              {(
                <Badge overflowCount={999} count={totalUnread}>
                  <Button type="primary" style={{ marginLeft: "10px" }} onClick={() => { queryConvsById(null, 0, '我', -1) }}>{userName}的消息</Button>
                </Badge>
              )}
            </>
          ) : (
            <Badge overflowCount={999} count={totalUnread}>
              <Button type="primary" style={{ marginLeft: "10px" }} onClick={() => { queryConvsById(null, 0, '我', -1) }}>{userName}的工单</Button>
            </Badge>
          )
        }
        <div className={styles.filters}>
          {
            isTenantMode &&
            (
              <Popover content={staffConvs?.toJS().map((item, index) => {
                return (<p key={index}>
                  <a onClick={() => { queryConvsById(item.user, -1, item.realname, item.unread) }}>
                    <Badge overflowCount={999} key={item.realname} count={item.unread} offset={[15, 5]} overflowCount={999}>
                      {item.realname}
                    </Badge>
                  </a>
                </p>)
              })} title="企业消息列表" trigger="hover" className={styles.message}>
                <Button type="primary"><Badge overflowCount={999} count={getTenantTotal(staffConvs?.toJS())} offset={[15, 5]} overflowCount={999}>企业消息</Badge></Button>
              </Popover>
            )
          }

          {isManagerMode && (
            <>
              <Popover content={<ConversationTabs conversations={groupManager?.toJS()} getTotal={getTotal} queryConvsById={queryConvsById} />} title="客服消息列表" trigger="hover" className={styles.message}>
                <Button type="primary"><Badge count={getTopTotal(groupManager?.toJS())} offset={[15, 5]} overflowCount={999}>客服组消息</Badge></Button>
              </Popover>
              <Radio.Group onChange={queryConvs} value={queryType}>
                <Radio value={1}><Badge count={unAcceptCount} overflowCount={999}>待接收</Badge></Radio>
                <Radio value={2}><Badge count={dateOverTimeCount} overflowCount={999}>预约超时</Badge></Radio>
                <Radio value={3}><Badge count={serviceOverTimeCount} overflowCount={999}>上门超时</Badge></Radio>
                <Radio value={4}><Badge count={unApprovalCount} overflowCount={999}>待审核</Badge></Radio>
              </Radio.Group>
            </>
          )}
        </div>
      </div> */}

      <div className={styles.content}>
        {isManagerMode && <div className={styles.contentblockwrap}>
          <Spin
            wrapperClassName={styles.spinclass}
            // spinning={taskLoading}
            spinning={false}
            delay={500}
            style={{ height: '100%' }}
          >
            <div className={styles.contentblock}>
              <div className={styles.blockheadwrap}>
                <div className={styles.blockhead}>
                  <div className={styles.headtabs}>
                    {!showTaskFold ? <>
                      <div className={cn(styles.tabitem, tastHallType == 0 ? styles.active : '')}>
                        <div className={styles.itemtext} onClick={() => { clickTastHallType(0) }}>任务大厅
                          <div className={styles.badgelist} onClick={e => e.stopPropagation()}>
                            {taskCount.opTipNum > 0 && <div className={styles.badgeitem}>
                              <Badge count={taskCount.opTipNum} style={{ transform: 'scale(0.8)' }} />
                              <span className={styles.itext}>待操作</span>
                            </div>}
                            {taskCount.tipNum > 0 && <div className={styles.badgeitem}>
                              <Badge count={taskCount.tipNum} style={{ transform: 'scale(0.8)', backgroundColor: '#0066FF' }} />
                              <span className={styles.itext}>提醒</span>
                            </div>}
                          </div>
                        </div>
                      </div>
                      <div className={cn(styles.tabitem, tastHallType == 1 ? styles.active : '')}>
                        <div className={styles.itemtext} onClick={() => { clickTastHallType(1) }}>超时任务
                          <div className={styles.badgelist} onClick={e => e.stopPropagation()}>
                            {chaoshiCount.chaoshi > 0 && <div className={styles.badgeitem}>
                              <Badge count={chaoshiCount.chaoshi} />
                            </div>}
                          </div>
                        </div>
                      </div>
                      <div className={cn(styles.tabitem, tastHallType == 6 ? styles.active : '')}>
                        <div className={styles.itemtext} onClick={() => { clickTastHallType(6) }}>保外工单
                          <div className={styles.badgelist} onClick={e => e.stopPropagation()}>
                            {baowaiCount.baowai > 0 && <div className={styles.badgeitem}>
                              <Badge count={baowaiCount.baowai} />
                            </div>}
                          </div>
                        </div>
                      </div>
                    </> :
                      <>
                        <PageHeader
                          onBack={() => { setShowTaskFold(false) }}
                          title="返回工单公屏"
                          subTitle="已处理工单"
                        />
                      </>
                    }

                  </div>
                </div>
                <div className={styles.tipsbtn} onClick={() => {
                  getTaskFoldData()
                  setShowTaskFold(true)
                }}>
                  <Divider dashed={true} style={{ color: '#17A55C', margin: 0 }}
                  >点击向上查看已接收工单</Divider>
                </div>
              </div>
              <div className={styles.blockbodywrap}>
                <div className={styles.blockbody} ref={taskListRef}>
                  <TaskHall taskList={taskList}
                    taskHallSelectOrderId={taskHallSelectOrderId}
                    showConvFold={showConvFold}
                    tastHallType={tastHallType}
                    change={(orderId, convId) => {
                      setTaskHallSelectOrderId(orderId)
                      setConvSelectOrderId('')
                    }}
                    resetTaskHall={() => {
                      fetchTaskData()
                    }}
                    onProcessedSuccess={() => {
                      fetchTaskCountData()
                      middleConvRef.current?.fetchList()
                    }}
                    onProcessedSuccessqqqq={(orderId, convId) => {
                      middleConvRef.current?.fetchList()
                      // setShowChatHistory(true)
                      middleConvRef.current?.chataaaa(orderId, convId)
                    }}

                  />
                </div>
              </div>
              <div style={{ padding: '5px 10px 10px', textAlign: 'right' }}>
                <Pagination
                  current={(offset / limit) + 1}
                  size="small"
                  total={total}
                  pageSize={limit}
                  showLessItems={true}
                  showQuickJumper={true}
                  showTotal={(total) => `共计 ${total}条`}
                  onChange={handleTaskChange}
                />
              </div>
              {showTaskFold && <div className={styles.foldview}>
                <div className={styles['foldview-view']}>
                  {taskFoldList.map((item, index) => (
                    <TaskItem
                      key={index}
                      convId={item.id}
                      item={item}
                      type="prevScreen"
                      taskHallSelectOrderId={taskHallSelectOrderId}
                      tastHallType={tastHallType}
                      change={(orderId, convId) => {
                        setTaskHallSelectOrderId(orderId)
                        setConvSelectOrderId('')
                      }}
                      resetTaskHall={() => {
                        fetchTaskData()
                      }}
                      onProcessedSuccess={() => {
                        // console.log(99999)
                        middleConvRef.current?.fetchList()
                        // setShowChatHistory(true)
                        // middleConvRef.current?.chataaaa()
                      }}
                    />
                  ))}
                </div>

                <div style={{ padding: '5px 10px 10px', textAlign: 'right' }}>
                  <Pagination
                    current={(taskFoldOffset / taskFoldLimit) + 1}
                    size="small"
                    total={taskFoldTotal}
                    pageSize={taskFoldLimit}
                    showLessItems={true}
                    showQuickJumper={true}
                    showTotal={(total) => `共计 ${total}条`}
                    onChange={handleTaskFoldChange}
                  />
                </div>
              </div>}
            </div>
          </Spin>
        </div>}
        <div className={styles.contentblockwrap}>
          <div className={styles.contentblock} id="middle-content-block">
            <div className={styles.blockheadwrap}>
              <div className={styles.blockhead}>
                <div className={styles.headtabs}>
                  {!showConvFold ? <>
                    <div className={cn(styles.tabitem)}
                      style={{ justifyContent: (isTenantMode || user?.get('isAdmin')) ? 'flex-start' : 'conter' }}>
                      {isTenantMode ?
                        (<div className={styles.itemtext} >工单公屏
                          <div className={styles.badgelist} onClick={e => e.stopPropagation()}>
                            {myCount.opTipNum > 0 && <div className={styles.badgeitem}>
                              <Badge count={myCount.opTipNum} style={{ transform: 'scale(0.8)' }} />
                              <span className={styles.itext}>待操作</span>
                            </div>}
                            {myCount.tipNum > 0 && <div className={styles.badgeitem}>
                              <Badge count={myCount.tipNum} style={{ transform: 'scale(0.8)', backgroundColor: '#0066FF' }} />
                              <span className={styles.itext}>提醒</span>
                            </div>}
                          </div>
                        </div>)
                        : (<div className={styles.itemtext} >
                          {Object.keys(activeStaff).length > 0 ? <span onClick={() => {
                            setActiveStaff({})
                            middleConvRef.current?.fetchList()
                          }}>{activeStaff?.user?.name}消息</span> : <span>我的消息</span>}
                          <div className={styles.badgelist} onClick={e => e.stopPropagation()}>
                            {myCount.opTipNum > 0 && <div className={styles.badgeitem}>
                              <Badge count={myCount.opTipNum} style={{ transform: 'scale(0.8)' }} />
                              <span className={styles.itext}>待操作</span>
                            </div>}
                            {myCount.tipNum > 0 && <div className={styles.badgeitem}>
                              <Badge count={myCount.tipNum} style={{ transform: 'scale(0.8)', backgroundColor: '#0066FF' }} />
                              <span className={styles.itext}>提醒</span>
                            </div>}
                          </div>
                        </div>)}
                    </div>
                  </> : <>
                    <PageHeader
                      onBack={() => { setShowConvFold(false) }}
                      title={isTenantMode ? "返回工单公屏" : "返回我的消息"}
                      subTitle={isTenantMode ? '已处理工单' : "我的已处理消息"}
                    />
                  </>}
                </div>
                {!showConvFold && isTenantMode && <div className={styles.headfilters}>
                  <Button
                    onClick={showOrderCreator.bind(this, user, id)}
                    type="primary"
                    className={styles.createBtn}
                  >
                    创建保内工单
                  </Button>

                  <RetailCode />

                  <div style={{ width: '380px', marginLeft: '10px' }}>
                    <SearchForm onChangeSearchData={(value) => {
                      middleConvRef.current?.searchData(value)
                    }}
                      wrappedComponentRef={searchFormRef}
                    />
                  </div>
                </div>}
                {user?.get('isAdmin') && <div className={styles.headfilters}>
                  <TeamMember
                    onChangeActiveStaff={(val) => {
                      setActiveStaff(val)
                      middleConvRef.current?.fetchList({
                        user_id: val?.user?._id
                      })
                    }}
                  >
                    <Button type="link" icon="swap">
                      切换员工
                    </Button>
                  </TeamMember>
                </div>}
              </div>
              {!showConvFold && <>{
                isTenantMode ?
                  (<div className={styles.tipsbtn} onClick={() => { setShowConvFold(true) }}>
                    <Divider dashed={true} style={{ color: '#17A55C', margin: 0 }}>点击向上查看已处理工单</Divider>
                  </div>) :
                  (<div className={styles.tipsbtn} onClick={() => { setShowConvFold(true) }}>
                    <Divider dashed={true} style={{ color: '#17A55C', margin: 0 }}>点击向上查看已处理工单</Divider>
                  </div>)
              }
              </>
              }
            </div>
            <div className={styles.blockbodywrap}>
              <div className={styles.blockbody}>
                <Conversations
                  className={styles.orderList}
                  showConvFold={showConvFold}
                  taskHallSelectOrderId={taskHallSelectOrderId}
                  setTaskHallSelectOrderId={setTaskHallSelectOrderId}
                  change={(params) => {
                    setTaskHallSelectOrderId('')
                    setConvSelectOrderId(params.orderId)
                  }}
                  onViewChatRecords={() => {
                    setShowChatHistory(true)
                  }}
                  resetTaskHall={() => {
                    fetchTaskData()
                  }}
                  ref={middleConvRef}
                />
              </div>
            </div>
          </div>
        </div>
        <div className={styles.contentblockwrap} style={{ maxWidth: isTenantMode ? 560 : 'auto', }}>
          <div className={styles.contentblock}>
            <div className={styles.blockheadwrap}>
              <div className={styles.blockhead}>
                <div className={styles.headtabs}>
                  <div className={cn(styles.tabitem, !showChatHistory && styles.active)}>
                    <div className={styles.itemtext} onClick={() => { setShowChatHistory(false) }}>工单详情</div>
                  </div>
                  <div className={cn(styles.tabitem, showChatHistory && styles.active)}>
                    <div className={styles.itemtext} onClick={() => { setShowChatHistory(true) }}>{isTenantMode ? '工单聊天' : '聊天历史'}</div>
                  </div>
                </div>
              </div>
            </div>
            <div className={styles.blockbodywrap}>
              <div className={styles.blockbody}>
                {
                  showChatHistory ?
                    (<>
                      {isManagerMode ? <div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
                        <MessageList
                          orderId={taskHallSelectOrderId || currentOrderId}
                          readOnly={true}
                        />
                      </div>
                        :
                        <MessageBox
                          orderId={taskHallSelectOrderId || currentOrderId}
                          convId={currentConvId}
                          isFold={convSelectOrderId ? true : false}
                          className={styles.message}
                        />}
                    </>)
                    :
                    <OrderDetail orderId={(taskHallSelectOrderId || currentOrderId)} />
                  // <OrderDetail orderId={currentOrderId} />
                }
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}


// function ConversationTabs({ conversations, queryConvsById, getTotal }) {
//   let category = new Map()
//   let fistKey = ''
//   conversations?.forEach(element => {
//     element.mgroup.forEach(mgroup => {
//       category.set(mgroup.name, new Set())
//       if (!fistKey) {
//         fistKey = mgroup.name
//       }
//     });
//   });
//   conversations?.forEach(element => {
//     element.mgroup.forEach(mgroup => {
//       if (category.has(mgroup.name)) {
//         //拷贝对象，分派到不同到客服组
//         category.get(mgroup.name).add(
//           {
//             user: element.user,
//             unread: mgroup.unread,
//             realname: element.realname,
//             mgroup: mgroup._id,
//             isWorking: element.isWorking
//           }
//         )
//       }
//     });
//   });
//   let tabs = []
//   category.forEach(function (value, key) {
//     tabs.push({ name: key, value: Array.from(value) })
//   })
//   let content = (<Tabs defaultActiveKey={fistKey}>
//     {
//       tabs.map((item, index) => {
//         return (<TabPane key={item.name} tab={<Badge overflowCount={999} count={getTotal(item.value)}>{item.name}</Badge>} key={item.name}>
//           {item.value && item.value.map((k, i) => {
//             return <p><a onClick={() => { queryConvsById(k.user, -1, k.realname, k.unread) }}><Badge count={k.unread} offset={[15, 5]} overflowCount={999} key={k.realname}>
//               {k.realname}({k.isWorking ? "在线" : "离线"})</Badge></a></p>
//           })}
//         </TabPane>)
//       })}
//   </Tabs>);
//   return tabs.length > 0 ? content : (<Empty></Empty>)
// }
export default withQuery(Workspace);
